export default __webpack_public_path__ + "static/media/delicious-burger.0e89f8c2.svg";